import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { Field, reduxForm } from 'redux-form';

import TextField from 'components/fields/TextField';

import Button from 'components/common/Button';

const styles = theme => ({
  gridItemShrink: {
    flexShrink: 1,
  },
  inputRoot: {
    padding: '2px 15px',
    boxSizing: 'border-box',
    width: '100%',
    borderRadius: 10,
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      borderRadius: 4,
      padding: 0,
    },
  },
  button: {
    '& + $button': {
      marginLeft: 24,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 8,
      },
    },
  },
  gridItemButtons: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: -5,
      top: -103,
    },
  },
  gridContainer: {
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },
});

const InventorySearchForm = ({
  handleSubmit,
  className,
  onFocus,
  onBlur,
  onKeyDown,
  onSubmitButtonClick,
  onCancelButtonClick,
  searchDisabled,
  submitButtonDisabled,
  submitButtonLoading,
  submitButtonText,
  cancelButtonText,
  searchInputRef,
  classes,
  width,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Grid

      container
      justify="flex-end"
      alignItems="center"
      spacing={24}
      wrap="nowrap"
    >
      <Grid className={classes.gridItemShrink} item xs={12}>
        <Grid
          className={classes.gridContainer}
          container
          justify="flex-start"
          alignItems="center"
          spacing={24}
          wrap="nowrap"
        >
          <Grid
            item
            xs={12}
            sm={5}
            className={classes.gridItem}
          >
            <Paper>
              <Field
                id="Product Name / HCPCS Code"
                name="Product Name / HCPCS Code"
                component={TextField}
                type={width === 'xs' ? 'text' : 'search'}
                placeholder="Add Line Item by Description or HCPCS"
                fullWidth
                startAdornmentClearButton
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                inputRootClassName={classes.inputRoot}
                disabled={searchDisabled}
                inputRef={searchInputRef}
              />
            </Paper>
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            className={classes.gridItem}
          >
            <Paper>
              <Field
                id="Vendor Name"
                name="Vendor Name"
                component={TextField}
                type={width === 'xs' ? 'text' : 'search'}
                placeholder="By Vendor"
                fullWidth
                startAdornmentClearButton
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                inputRootClassName={classes.inputRoot}
                disabled={searchDisabled}
                inputRef={searchInputRef}
              />
            </Paper>
          </Grid>
          <Grid
            item
            xs={6}
            sm={3}
            className={classes.gridItem}
          >
            <Paper>
              <Field
                id="Model"
                name="Model"
                component={TextField}
                type={width === 'xs' ? 'text' : 'search'}
                placeholder="By Model"
                fullWidth
                startAdornmentClearButton
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                inputRootClassName={classes.inputRoot}
                disabled={searchDisabled}
                inputRef={searchInputRef}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      {onSubmitButtonClick &&
        <Grid item className={classes.gridItemButtons}>
          <Button
            variant="raised"
            size="lg"
            className={classes.button}
            onClick={onCancelButtonClick}
          >
            {cancelButtonText}
          </Button>
          <Button
            variant="raised"
            color="primary"
            size="lg"
            className={classes.button}
            onClick={onSubmitButtonClick}
            disabled={submitButtonDisabled}
            loading={submitButtonLoading}
          >
            {submitButtonText}
          </Button>
        </Grid>
      }
    </Grid>
  </form>
);

InventorySearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSubmitButtonClick: PropTypes.func,
  onCancelButtonClick: PropTypes.func,
  searchDisabled: PropTypes.bool,
  submitButtonDisabled: PropTypes.bool,
  submitButtonLoading: PropTypes.bool,
  submitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  searchInputRef: PropTypes.func,
  classes: PropTypes.shape({
    inputRoot: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

InventorySearchForm.defaultProps = {
  className: '',
  onFocus: () => {},
  onBlur: () => {},
  onKeyDown: () => {},
  searchInputRef: () => {},
  onSubmitButtonClick: null,
  onCancelButtonClick: null,
  submitButtonDisabled: null,
  submitButtonLoading: null,
  submitButtonText: null,
  cancelButtonText: null,
  searchDisabled: false,
};

export default reduxForm({
  form: 'inventorySearchForm',
})(withStyles(styles)(withWidth()(InventorySearchForm)));



// WEBPACK FOOTER //
// ./src/components/inventory/InventorySearch/InventorySearchForm.js